import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const YachtsFleetPage = withSuspense(
	lazy(async () => await import('./yachts-fleet-page.component')),
	PageLoader,
);
